import { render, staticRenderFns } from "./FrequencyTablewithPieBar.vue?vue&type=template&id=2090dc00"
import script from "./FrequencyTablewithPieBar.vue?vue&type=script&lang=js"
export * from "./FrequencyTablewithPieBar.vue?vue&type=script&lang=js"
import style0 from "./FrequencyTablewithPieBar.vue?vue&type=style&index=0&id=2090dc00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports